


































































































import Vue, { VNode } from 'vue';
import { Component, Prop, Inject, Watch } from 'vue-property-decorator';
import { Subscription } from 'rxjs';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { SwTransitionExpand } from '../sw-transition';
import SwNav from './sw-nav.vue';
import SwNavItem from './sw-nav-item.vue';
import {
  ProvidedNavParam,
} from './types';
import { dropdown, DropdownDirValues } from '../dropdown-dir';
import { utilService } from '../util-service';

const cssPrefix = 'sw-nav-group';

@Component({
  components: {
    SwIcon,
    SwTransitionExpand,
    SwNavItem,
  },
  directives: {
    dropdown,
  },
})
export default class SwNavGroup extends SwExtendedVue {
  @Prop({ type: String, required: true })
  navId: string;

  @Prop({ type: Number, default: 0 })
  offsetLevel: number;

  @Prop({ type: Boolean, default: true })
  expandOnMount: boolean;

  @Prop({ type: Boolean, default: false })
  showMenuInsteadOfTooltipOnHover: boolean;

  cssPrefix = cssPrefix;

  showMenuBecauseOfHover = false;
  eventSubscription: Subscription | null = null;

  @Inject()
  readonly navParam: ProvidedNavParam;

  @Inject()
  private claimExpandedGroup: SwNav['claimExpandedGroup'];

  @Inject()
  private claimHighlightReferrer: SwNav['claimHighlightReferrer'];

  @Inject()
  private claimCheckHighlightReferrerRequest: SwNav['claimCheckHighlightReferrerRequest'];

  get isSelected(): boolean {
    return this.navParam.selectedHierarchy.findIndex(e => (e === this.navId)) >= 0;
  }

  public get isExpanded(): boolean {
    const levelReg = this.navParam.expandedGroups[this.offsetLevel];
    return !!levelReg && levelReg.indexOf(this.navId) >= 0;
  }

  get isCollapsed(): boolean {
    return this.navParam.collapsed;
  }

  get subNavItemsDropdown(): DropdownDirValues {
    return {
      enabled: this.isCollapsed,
      content: (h): VNode => { // tslint:disable-line
        const items = utilService.getVueScopedSlot(this.$scopedSlots);
        return (
          <div class={[`${this.cssPrefix}__sub-nav`]} on-mouseenter={this.onMouseEnter} on-mouseleave={this.onMouseLeave} >
            <div
              class={[
                `${this.cssPrefix}__sub-nav-header`,
                `${this.cssPrefix}__sub-nav-header--${this.navParam.size}`,
                'sw-typo-heading-3',
                'sw-flexbox',
                'sw-flexbox--center-items',
              ]}
            >
              { utilService.getVueScopedSlot(this.$scopedSlots, 'title-content') }
            </div>
            { items }
          </div>
        ) as VNode;
      },
      maxHeight: 1000,
      withArrow: false,
      trigger: 'controlled',
      visible: this.isExpanded || this.showMenuBecauseOfHover,
      placement: 'right-start',
      parentComponentInstance: this,
      customClasses: [`${this.cssPrefix}__sub-nav-cont`],
      onClickOutsidePopper: () => { this.toggle(false); },
    };
  }

  @Watch('isSelected')
  private checkClaimHighlight() {
    if (!this.isSelected || (this.isExpanded && !this.isCollapsed)) { return; }
    if (!this.$refs.titleItem) { return; }
    const rect = (this.$refs.titleItem as Vue).$el.getBoundingClientRect();
    this.claimHighlightReferrer(this.navId, {
      top: rect.top,
      left: rect.left,
      right: rect.right,
      bottom: rect.bottom,
      width: rect.width,
      height: rect.height,
    });
  }

  @Watch('isExpanded')
  private onExpandedChanged() {
    this.claimCheckHighlightReferrerRequest();
  }

  @Watch('isCollapsed')
  private onCollapsedChange() {
    if (this.isCollapsed && this.isExpanded) {
      this.toggle(false);
    } else if (!this.isCollapsed) {
      this.expandIfSelected();
    }
  }

  @Watch('$route')
  private onRouteChange() {
    if (this.expandOnMount) {
      this.expandIfSelected();
    }
  }

  public toggle(toExpand?: boolean) {
    const expanded = typeof toExpand === 'boolean' ? toExpand : !this.isExpanded;
    if (!this.isCollapsed) {
      /** when the nav is not collapsed, we don't allow group to be collapsed vertically if it is selected */
      if (this.isSelected && !expanded) { return; }
    }
    this.claimExpandedGroup(this.offsetLevel, this.navId, expanded);
  }

  private expandIfSelected() {
    this.$nextTick(() => {
      if (!this.isExpanded && this.isSelected) {
        this.toggle();
      }
    });
  }

  private onClickTitle() {
    this.toggle();
  }

  private onMouseLeave () {
    this.showMenuBecauseOfHover = false;
  }

  private onMouseEnter () {
    this.showMenuBecauseOfHover = true;
  }

  private created() {
    this.eventSubscription = this.navParam.eventbus.subscribe((event) => {
      if (event !== 'request-check-highlight-referrer') { return; }
      this.checkClaimHighlight();
    });
  }

  private mounted() {
    this.$nextTick(() => {
      this.checkClaimHighlight();
      if (this.expandOnMount) {
        this.expandIfSelected();
      }
    });
  }

  private beforeDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
      this.eventSubscription = null;
    }
  }
}
